import React, { useState, useEffect } from 'react';
import { Form, Modal, notification, Select, Input, Radio, Col, Row } from 'antd';
import { IDownloadedData } from '/react4xp/parts/admin-dictionary/admin-dictionary';
import {
    addDictionary,
    getAutomatedDictionary,
    getDownloadableDictionary,
} from '/react4xp/parts/admin-dictionary/actions';
import Button from '/react4xp/mixins/ui/button/button';
import { LOCALIZED_DATA } from '../admin-dictionary.constants';
import { LanguageRow } from './language-row';

type Props = {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    setDownloadedDictionaries: (downloadedDictionaries: IDownloadedData[]) => void;
};

const CreateDictionaryModal: React.FC<Props> = ({
    isOpen,
    setIsOpen,
    setDownloadedDictionaries,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [dictionaryList, setDictionaryList] = useState([]);
    const [checkboxType, setCheckboxType] = useState('select');
    const [form] = Form.useForm();

    useEffect(() => {
        getAutomatedDictionary({
            source: 'UPLOADED',
        }).then(({ data }) => {
            setDictionaryList(data);
        });
    }, []);

    const handleCreateDictionary = (values: any) => {
        form.validateFields().then(() => {
            setIsLoading(true);
            debugger;
            const formData = new FormData();
            Object.entries(values).forEach(([key, value]) => {
                if (value)
                    formData.append(key, Array.isArray(value) ? value[0].originFileObj : value);
            });
            addDictionary(formData)
                .then(() => {
                    notification.success({
                        message: 'Справочник успешно добавлен!',
                        duration: 3,
                    });

                    return getDownloadableDictionary({
                        latest: false,
                    }).then(({ data }) => {
                        setDownloadedDictionaries(data);
                    });
                })
                .finally(() => {
                    setIsLoading(false);
                    setIsOpen(false);
                });
        });
    };

    return (
        <Modal
            title="Создание справочника"
            open={isOpen}
            onCancel={() => setIsOpen(false)}
            footer={[
                <Button
                    key="cancel"
                    onClick={() => setIsOpen(false)}
                >
                    Отмена
                </Button>,
                <Button
                    key="add"
                    type="primary admin"
                    onClick={() => handleCreateDictionary(form.getFieldsValue())}
                    loading={isLoading}
                >
                    Добавить
                </Button>,
            ]}
        >
            <div>
                <Form
                    layout="vertical"
                    form={form}
                    onFinish={handleCreateDictionary}
                >
                    <Row gutter={16}>
                        <Col span={12}>
                            <Radio.Group
                                size="small"
                                onChange={(e) => {
                                    const { value } = e.target;
                                    setCheckboxType(value);
                                    if (value !== 'select') {
                                        form.resetFields(['dictCode']);
                                    }
                                }}
                                value={checkboxType}
                            >
                                <Radio value="select">Выбрать из списка</Radio>
                                <Radio value="new">Добавить новый</Radio>
                            </Radio.Group>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Справочник"
                                name="dictCode"
                                required={true}
                            >
                                <Select
                                    placeholder="Справочник"
                                    size="large"
                                    showSearch
                                    disabled={checkboxType === 'new'}
                                    filterOption={(input, option) =>
                                        option.children
                                            .toString()
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                    }
                                >
                                    {dictionaryList.map((dictionary) => (
                                        <Select.Option
                                            key={dictionary.id}
                                            value={dictionary.code}
                                            title={dictionary.ru}
                                        >
                                            {dictionary.ru}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item
                        name="description"
                        label="Описание"
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                    >
                        <Input placeholder="Введите описание" />
                    </Form.Item>
                    {LOCALIZED_DATA.map((item) => (
                        <LanguageRow
                            key={item.lang}
                            {...item}
                        />
                    ))}
                </Form>
            </div>
        </Modal>
    );
};

export default CreateDictionaryModal;
